<template>
    <div v-if="values" class="d-flex align-items-start flex-column">
        <div class="mt-2 mb-2 text-danger mb-4 font-weight-bold">
            Warning: PayPal is not a Credit Card direct payment gateway and cannot be used for integrations.
        </div>
        <validation-observer
            v-if="isEdit"
            :initialValues="{
                paypal_email: values.gateway.paypal_email,
                paypal_username: values.gateway.paypal_username,
                paypal_password: values.gateway.paypal_password,
                paypal_signature: values.gateway.paypal_signature,
            }"
            v-slot="{ meta, errors, setFieldValue }"
            class="d-block form-wrapper"
            validateOnMount
        >
            <validation-provider name="paypal_email" rules="required|email">
                <form-input
                    :error="errors.paypal_email"
                    v-model="values.gateway.paypal_email"
                    @input="(val) => setFieldValue('paypal_email', val)"
                    label="PayPal Email:"
                />
            </validation-provider>
            <validation-provider name="paypal_username" rules="required">
                <form-input
                    :error="errors.paypal_username"
                    @input="(val) => setFieldValue('paypal_username', val)"
                    v-model="values.gateway.paypal_username"
                    label="API Username:"
                />
            </validation-provider>
            <validation-provider name="paypal_password" rules="required">
                <form-input
                    type="password"
                    :error="errors.paypal_password"
                    v-model="values.gateway.paypal_password"
                    label="API Password:"
                    @input="(val) => setFieldValue('paypal_password', val)"
                />
            </validation-provider>

            <validation-provider name="paypal_signature" rules="required">
                <form-input
                    :error="errors.paypal_signature"
                    @input="(val) => setFieldValue('paypal_signature', val)"
                    v-model="values.gateway.paypal_signature"
                    label="Signature:"
                />
            </validation-provider>
            <form-checkbox v-model="values.gateway.paypal_auto_approve_payments"> Auto Approve Payments </form-checkbox>
            <form-textarea class="mt-2" label="PayPal Details:" v-model="values.gateway.paypal_details" :rows="10" />
            <a
                class="link"
                href="http://docs.lodgix.com/m/5502/l/29195-how-do-i-setup-paypal-to-integrate-with-lodgix-com"
                target="_blank"
                >Instructions on how to obtain PayPal API credentials</a
            >
            <div class="submit-buttons-wrapper">
                <b-button :disabled="!meta.valid" class="mr-2" variant="primary" @click="onSave">Save</b-button>
                <b-button variant="default" @click="onCancel">Cancel</b-button>
            </div>
        </validation-observer>
        <div v-else class="w-100 d-flex flex-column paypal-gap">
            <div class="d-flex flex-column align-items-start">
                <span>PayPal Email:</span>
                <h3 class="text-primary" @click="onEdit">{{ values.gateway.paypal_email }}</h3>
            </div>
            <div class="d-flex flex-column align-items-start">
                <span>API Username:</span>
                <h3 class="text-primary" @click="onEdit">{{ values.gateway.paypal_username }}</h3>
            </div>
            <div class="d-flex flex-column align-items-start">
                <span>API Password: </span>
                <h3 class="text-primary" @click="onEdit">***************</h3>
            </div>
            <div class="d-flex flex-column align-items-start">
                <span>Signature:</span>
                <h3 class="text-primary paypal-signature" @click="onEdit">{{ values.gateway.paypal_signature }}</h3>
            </div>
            <div class="d-flex align-items-center">
                <h3 @click="onEdit" class="text-primary mr-4">
                    {{ values.gateway.paypal_auto_approve_payments ? 'On' : 'Off' }}
                </h3>
                <span> Auto Approve Payments</span>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
    import { paymentComponentMixin } from './mixin';
    import { initial } from 'lodash';

    export default {
        name: 'PaypalEdit',
        components: {
            FormInput,
            FormCheckbox,
            FormTextarea,
        },
        mixins: [paymentComponentMixin],
        computed: {
            isGatewayNone() {
                return this.values && this.values.gateway.id === NONE_ID;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form-wrapper {
        width: 50%;
        @media (max-width: 968px) {
            width: 100%;
        }
    }
    .paypal-gap {
        gap: 1rem;
    }

    .paypal-signature {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
